// Helper functions for gathering translations for channels availability for each product on listing page
import uiLocale from './UILocale';

export const getDefaultChannelsAvailabilityTranslation = (productType, state) => {
  switch (productType) {
    case 'forwardOrder': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.preorder_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.preorder_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.preorder_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'preOrder': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.preorder_delivery_date');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.preorder_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.preorder_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'sbre': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.sbre_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.sbre_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.sbre_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.sbre_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'shd': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.extendedrange_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.extendedrange_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.extendedrange_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.extendedrange_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'small-box': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.sb_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.default_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.default_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'big-box': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.bb_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.default_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.default_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }
    }
    case 'outfit': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.bundle_listing_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.bundle_listing_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.default_listing_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.bundle_listing_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.bundle_listing_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'tariff': {
      switch (state) {
        case 'deliverable': {
          return uiLocale.getString('component.mcd.tariff_initial_delivery_state_deliverable');
        }
        case 'undeliverable': {
          return uiLocale.getString('component.mcd.tariff_initial_delivery_state_undeliverable');
        }
        case 'undeliverableForbidden': {
          return uiLocale.getString('component.mcd.tariff_initial_delivery_state_undeliverable_forbidden');
        }
        case 'collectable': {
          return uiLocale.getString('component.mcd.tariff_initial_collection_state_collectable');
        }
        case 'uncollectable': {
          return uiLocale.getString('component.mcd.tariff_initial_collection_state_uncollectable');
        }
        default: {
          return '';
        }
      }

    }
    case 'download': {
      switch (state) {
        case 'availableToDownload': {
          return uiLocale.getString('component.productlisting.downloadLabel');
        }
        default: {
          return '';
        }
      }
    }

    default: {
      return '';
    }
  }
};
